export default "__VITE_ASSET__Uw0e2GRQ__"